import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { Input, Select } from 'alurkerja-ui'
import { Dispatch, SetStateAction } from 'react'
import { includes } from 'lodash'

interface NumberSeparatorProps {
  separator: {
    currency: string
    separator: {
      type: string
      thousand: string
      decimal: string
    }
  }
  setSeparator: Dispatch<SetStateAction<{
    currency: string
    separator: {
      type: string
      thousand: string
      decimal: string
    }
  }>>
}

export default function NumberSeparator (props: NumberSeparatorProps) {
  const currencyOptions = [
    { value: '', label: 'None' },
    { value: 'Rp', label: 'IDR' },
    { value: '$', label: 'USD' },
  ];

  const separatorOptions = [
    { value: '', label: 'None' },
    { value: 'separator_thousand', label: 'Separator Thousand' },
    { value: 'separator_decimal', label: 'Separator Decimal' },
    { value: 'separator_thousand_decimal', label: 'Separator Thousand & Decimal' },
    { value: 'separator_customthousand_decimal', label: 'Separator Custom Thousand & Decimal' },
  ];

  return <>
    <div
      className={'mt-2'}
    >
      <span className="font-semibold">{stringToTitleCase('currency')}</span>
      <Select
        styles={{
          control: () => ({}),
          valueContainer: () => ({
            display: 'flex',
            flexWrap: 'wrap',
            flex: 1,
            alignItems: 'center',
            overflow: 'hidden',
          }),
          input: () => ({ gridArea: '1 / 1 / 2 / 3' }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#0095E8' : '#fff',
            ':hover': { backgroundColor: '#E4E6EF', color: '#000' },
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: '200px',
            overflowY: 'auto',
          }),
        }}
        classNames={{
          control: () =>
            'h-9 text-sm px-2.5 flex rounded-lg border py-2 bg-white focus:ring-main-blue-alurkerja focus-within:ring-main-blue-alurkerja focus-within:border-main-blue-alurkerja focus:border-main-blue-alurkerja',
          valueContainer: () => 'p-0 overflow-hidden relative grid items-center flex-1',
          input: () => 'visible',
        }}
        isSearchable={false}
        options={currencyOptions}
        onChange={(newValue: any) => props.setSeparator({
          ...props.separator,
          currency: newValue.value
        })}
        defaultValue={currencyOptions.find(option => option.value === props.separator.currency)}
      />
    </div>

    <div
      className={'mt-2'}
    >
      <span className="font-semibold">{stringToTitleCase('separator')}</span>
      <Select
        styles={{
          control: () => ({}),
          valueContainer: () => ({
            display: 'flex',
            flexWrap: 'wrap',
            flex: 1,
            alignItems: 'center',
            overflow: 'hidden',
          }),
          input: () => ({ gridArea: '1 / 1 / 2 / 3' }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#0095E8' : '#fff',
            ':hover': { backgroundColor: '#E4E6EF', color: '#000' },
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: '200px',
            overflowY: 'auto',
          }),
        }}
        classNames={{
          control: () =>
            'h-9 text-sm px-2.5 flex rounded-lg border py-2 bg-white focus:ring-main-blue-alurkerja focus-within:ring-main-blue-alurkerja focus-within:border-main-blue-alurkerja focus:border-main-blue-alurkerja',
          valueContainer: () => 'p-0 overflow-hidden relative grid items-center flex-1',
          input: () => 'visible',
        }}
        isSearchable={false}
        options={separatorOptions}
        onChange={(newValue: any) => props.setSeparator({
          ...props.separator,
          separator: {
            ...props.separator.separator,
            type: newValue.value,
            decimal: (newValue.value === 'separator_decimal' || newValue.value === 'separator_customthousand_decimal' || newValue.value === 'separator_thousand_decimal') ? '.' : '',
            thousand: (newValue.value === 'separator_thousand'  || newValue.value === 'separator_thousand_decimal') ? ',' : ''
          }
        })}
        defaultValue={separatorOptions.find(option => option.value === props.separator.separator.type)}
      />

      {includes(props.separator.separator.type, 'separator_customthousand_decimal') && (
        <Input
          className="w-full mt-1"
          type="text"
          size="sm"
          rounded="lg"
          placeholder={'Separator Custom Thousand'}
          onChange={(e) => {
            if(e.target.value.length <= 0) {
              props.setSeparator({
                ...props.separator,
                separator: {
                  ...props.separator.separator,
                  thousand: ''
                }
              })
            } else {
              props.setSeparator({
                ...props.separator,
                separator: {
                  ...props.separator.separator,
                  thousand: e.target.value
                }
              })
            }
          }}
        />
      )}
    </div>
  </>
}